import {v4 as uuid} from "uuid";
import {REST_SERVER_CHAT_URL, WS_SERVER_CHAT_URL} from "../constants";
import {LongPullClient} from "./LongPullClient";
import axios from "axios";

export class ChatTransportClient{

    handlers;
    sessionId;
    dialogId;
    wsClient;
    lpClient;
    currentTransport;

    constructor(dialogId, handlers) {
        this.sessionId = uuid();
        this.handlers = handlers;
        this.dialogId = dialogId;
        this.currentTransport = 'ws';
    }

    run(){
        if(this.currentTransport === 'ws'){
            this._runWSClient();
        }else if(this.currentTransport === 'lp'){
            this._runLongPulling();
        }
    }

    _runWSClient(){
        const timer = setTimeout(() => {
            this.currentTransport = 'lp';
            this.wsClient.close(1000, 'ws transport not working');
            this.run();
        }, 3000);

        this.wsClient = new WebSocket(WS_SERVER_CHAT_URL+'/dialogId/'+this.dialogId+'?session='+this.sessionId);
        this.wsClient.onmessage = (event) => {
            clearTimeout(timer);
            const res = JSON.parse(event.data);
            if(this.handlers.onMessage) {
                this.handlers.onMessage(res);
            }
        };
        this.wsClient.onopen = this.handlers?.onOpen;
        this.wsClient.onclose = (event) => {
            if(this.handlers.onClose) {
                this.handlers.onClose(event)
            }
            if(!event.wasClean) {
                this.currentTransport = 'lp';
                this.run();
            }
        }
        this.wsClient.onerror = this.handlers?.onError;
    }

    async _runLongPulling(){
        const {data} = await axios.get(REST_SERVER_CHAT_URL+'/getchat?dialogId='+this.dialogId);
        this.handlers.onMessage(data);
        this.lpClient = new LongPullClient(REST_SERVER_CHAT_URL+'/getchat/events?dialogId='+this.dialogId, this.sessionId, this.handlers);
        this.lpClient.open();
    }

    stop(){
        if(this.currentTransport === 'ws'){
            this.wsClient.close(1000, 'good');
        }else if(this.currentTransport === 'lp'){
            this.lpClient.stop();
        }
    }
}